<lib-content-section [contentSectionObj]="sectionObj" *ngFor="let sectionObj of contentSectionList"></lib-content-section>